export default __webpack_public_path__ + "static/media/clover.f3344285.gif";